import type { CSSProperties } from 'react';
import { entriesOf, ROUNDS, type GameId } from './game';

// A classic space-invader-style sprite: the boss, "The Backlog". X = filled pixel.
const BACKLOG = [
  '..X.....X..',
  '...X...X...',
  '..XXXXXXX..',
  '.XX.XXX.XX.',
  'XXXXXXXXXXX',
  'X.XXXXXXX.X',
  'X.X.....X.X',
  '...XX.XX...',
];

export function Backlog({ size = 12, color = '#B14CFF' }: { size?: number; color?: string }) {
  return (
    <svg className="backlog" width={11 * size} height={8 * size} viewBox="0 0 11 8" shapeRendering="crispEdges" aria-hidden="true">
      {BACKLOG.flatMap((row, y) => [...row].map((c, x) => c === 'X' ? <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={color} /> : null))}
    </svg>
  );
}

const bandCovers = entriesOf('Bands').filter(e => e.image).slice(0, 3);
const gameCovers = entriesOf('Games').filter(e => e.image).slice(0, 4);

// Each game's cover art for the selection carousel. Deliberately off-brand: these are arcade posters.
export default function GamePoster({ id }: { id: GameId }) {
  if (id === 'blur') return (
    <div className="poster poster-blur">
      <div className="pb-sun" />
      <div className="pb-covers">
        {bandCovers.map((e, i) => <img key={e.name} src={e.image} alt="" style={{ '--i': i - 1 } as CSSProperties} />)}
      </div>
      <p className="poster-kicker">Name that band</p>
      <h3 className="poster-title">Blurry<br />cover</h3>
      <p className="poster-foot">{entriesOf('Bands').length} bands · {ROUNDS} rounds</p>
    </div>
  );
  if (id === 'plot') return (
    <div className="poster poster-plot">
      <div className="pp-strip" />
      <p className="poster-kicker">In a world where plots make no sense…</p>
      <h3 className="poster-title">Badly<br />explained<br />plot</h3>
      <p className="pp-stars">★★★★★</p>
      <p className="poster-foot">“Technically accurate.” – Isak</p>
      <div className="pp-strip" />
    </div>
  );
  return (
    <div className="poster poster-boss">
      <div className="pf-covers">
        {gameCovers.map(e => <img key={e.name} src={e.image} alt="" />)}
      </div>
      <p className="poster-kicker">VS. The Backlog</p>
      <Backlog size={14} />
      <h3 className="poster-title">Boss<br />fight</h3>
      <p className="poster-foot">3 ♥ · {ROUNDS} questions · no continues</p>
    </div>
  );
}
